import Vue from "vue";

// v-focus um Input-Felder automatisch zu fokusieren
Vue.directive("focus", {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {
        // Focus the element
        el.focus();
    }
});